import React from 'react';
import { FedopsLoggerStore } from '../../stores/FedopsLoggerStore';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { BILoggerStore } from '../../stores/BILoggerStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { Template } from './Template/Template';
import s from './Templates.scss';

interface TemplatesProps {
  fedopsLoggerStore: FedopsLoggerStore;
  templatesStore: TemplatesStore;
  biLoggerStore: BILoggerStore;
  dataHook?: string;
}

const TemplatesCmp: React.FC<TemplatesProps> = ({ templatesStore, dataHook, biLoggerStore, fedopsLoggerStore }) => {
  const { items, responseUuid, bestMatchItemIds } = templatesStore;

  React.useEffect(() => {
    fedopsLoggerStore.stopActiveInteraction();
    biLoggerStore.logPageFullyRendered(biLoggerStore.getLastInteractionKey());
    biLoggerStore.logTemplatesLoaded();
  }, [fedopsLoggerStore, responseUuid, biLoggerStore]);

  return (
    <ul className={s.templates} data-hook={dataHook}>
      {items.map((template, index) => (
        <Template
          key={template.id}
          dataHook="template"
          template={template}
          galleryDocIndex={index}
          hasMatchBadge={bestMatchItemIds.includes(template.id)}
        />
      ))}
    </ul>
  );
};

export const Templates = injectStoresV2('templatesStore', 'biLoggerStore', 'fedopsLoggerStore')(TemplatesCmp);
